module.exports = __webpack_public_path__ + "static/media/btn-nav-mobile-expanded.404cad14.svg";